const { api } = require('@cashew/utils');

export const getInstallmentDetails = (
  orderId: string,
  setProduct: any,
  setPaidAmount: any,
  setNextPayment: any,
  history: any
) => {
  api
    .get({
      endpoint: `products/options/${orderId}`,
    })
    .then((resp: any) => {
      const { data } = resp;
      const paid = data.subProducts[0].installments.filter(
        (item: any) => item.status === 'PAID'
      );
      const pending = data.subProducts[0].installments.filter(
        (item: any) => item.status === 'PENDING'
      );
      setNextPayment(pending[0]);
      setPaidAmount(
        paid
          .reduce(
            (acc: any, item: any) => ({
              total:
                item.installmentAmount +
                item.latePaymentAmount +
                item.latePaymentAmountVat +
                acc.total,
            }),
            { installmentAmount: 0, latePaymentAmount: 0, total: 0 }
          )
          .total.toFixed(2)
      );
      setProduct(data);
    })
    .catch((resp: any) => {
      api.errorHandler({ resp, history });
    });
};

export const useGetOrderDetails = (
  orderId: string,
  setOrderDetails: any,
  setLoading: any,
  dispatch: any,
  t: any
) => {
  setLoading(true);
  api
    .get({
      endpoint: `orders/${orderId}`,
    })
    .then(async (resp: any) => {
      const hasCustomer = false;
      // const hasCustomer = !!resp.data.customer;
      if (!hasCustomer) {
        await api
          .get({
            endpoint: `orders/${orderId}/customer`,
          })
          .then((customerResponse: any) => {
            // eslint-disable-next-line no-param-reassign
            resp.data.customer = customerResponse.data;
          })
          .catch((error: any) => {
            console.log(error);
          });
      }
      setOrderDetails(resp.data);
    })
    .catch(() =>
      dispatch({
        type: 'OPEN_TOASTER',
        payload: {
          toasterTitle: t('orderDetails.error.fetchDetails.title'),
          toasterMessage: t('orderDetails.error.fetchDetails.message'),
          toasterType: 'error',
          toasterVisible: true,
          toasterDismiss: null,
        },
      })
    )
    .finally(() => {
      setLoading(false);
    });
};
